import './FieldNode.scss';
import React from 'react';
import { UnorderedListOutlined } from '@ant-design/icons';
import { mapFlowNodeType, mapReportComponentType } from '@sonar-software/sonar-ts-lib';
import { Tag, Tooltip } from 'antd';

export interface FieldNodeProps {
	name: string;
	type?: string;
}

function getFieldNode(name: string | undefined | null) {
	return (
		<Tag icon={ <UnorderedListOutlined /> }>
			{ name }
		</Tag>
	);
}

export const FieldNode: React.FC<FieldNodeProps> = ({ name, type }) => {
	const mappedName = type ? name : mapReportComponentType(name);
	const fieldNodeBase = getFieldNode(mappedName);

	if (!type) {
		return fieldNodeBase;
	}

	const nodeType = mapFlowNodeType(type);

	return (
		<Tooltip
			overlay={ `${nodeType} Relationship` }
			placement='bottomLeft'>
			{ fieldNodeBase }
		</Tooltip>
	);
};
